import { render, staticRenderFns } from "./ImagesUpload.vue?vue&type=template&id=12c6cd1b&"
import script from "./ImagesUpload.vue?vue&type=script&lang=js&"
export * from "./ImagesUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImagesUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports